import { INormalizedShipItemList } from '@interfaces/ship';
import { IShipItem } from '../../../../interfaces/ship/IShip';
import React from 'react';
import { TranslationService, __ } from '../../../utils/translation-service';
import { NextImage } from '../../atoms/image/image';
import { ShipColumn } from './ship-column/ship-column';
import { shipDetailItemsLabels } from './ship-detail-label';
import { StyledShipDetailBg } from './ship-detail.style';

interface IProps {
    shipItems: IShipItem;
}

export const ShipDetail = (props: IProps) => {
    const { shipItems } = props;

    if (!shipItems) return null;

    const url = shipItems.backgroundImage?.image?.url || shipItems.bannerImage || '';
    const thumb = shipItems.backgroundImage?.thumb?.url || '';

    if (!url) return null;

    return (
        <StyledShipDetailBg>
            <NextImage
                fill
                isBackground
                placeholder={thumb}
                imgUrl={url}
                style={{
                    objectFit: 'cover',
                }}
            >
                {
                    <ShipColumn
                        shipItems={normalizeShipTableData(shipItems)}
                        headline={TranslationService.translate('shipDetail')}
                    />
                }
            </NextImage>
        </StyledShipDetailBg>
    );
};

const normalizeShipTableData = (items: IShipItem) => {
    const shipDetailItems: INormalizedShipItemList = shipDetailItemsLabels;

    Object.entries(items).forEach(([key, entry]) => {
        if (!(key in shipDetailItems) || !entry) return;

        if (key === 'speed') {
            shipDetailItems[key].value = `${entry} ${__('knots')}`;
        } else if (key === 'length' || key === 'draft') {
            shipDetailItems[key].value = `${entry} ${__('metre')}`;
        } else {
            shipDetailItems[key as keyof INormalizedShipItemList].value = entry;
        }
    });

    return shipDetailItems;
};

export default ShipDetail;
